/**
 * What a configured phone number is able to be used for. primary derives this from the number's
 * capabilities rather than storing it, so it is a read-only summary of the capability set.
 *
 * The `SMS` member names keep primary's all-caps casing rather than the repo's `Sms` — see
 * `PhoneNumberCapabilityChannel`.
 */
export var PhoneNumberFunction;
(function (PhoneNumberFunction) {
    PhoneNumberFunction["InboundVoiceTrigger"] = "InboundVoiceTrigger";
    PhoneNumberFunction["OutboundVoiceCallWithAssistant"] = "OutboundVoiceCallWithAssistant";
    PhoneNumberFunction["OutboundSMSMessage"] = "OutboundSMSMessage";
    PhoneNumberFunction["InboundSMSConversation"] = "InboundSMSConversation";
})(PhoneNumberFunction || (PhoneNumberFunction = {}));
//# sourceMappingURL=phoneNumberFunction.js.map